import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../../Api/Endpoints";

export const fetchApiData = createAsyncThunk(
  "api/fetchData",
  async ({ userId, clientId, clientBranchId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("other");
      const url = `${EndPoints.CLIENT_LANDING_PAGE_INFO_V2}?client_id=${clientId}&user_id=${userId}&client_branch_id=${clientBranchId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const err = await response.text();
        return rejectWithValue(err);
      }

      const responseData = await response.json();
    
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const landingSlice = createSlice({
  name: "landing",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetLandingState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApiData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApiData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const { resetLandingState } = landingSlice.actions;
export default landingSlice.reducer;